export default __webpack_public_path__ + "static/media/mlodz11.f05fb158.jpg";